import axios from "axios";
import { toast } from "react-toastify";
const baseUrl = process.env.REACT_APP_BASE_URL;

export const CREATE_THEME_REQUEST = "CREATE_THEME_REQUEST";
export const CREATE_THEME_SUCCESS = "CREATE_THEME_SUCCESS";
export const CREATE_THEME_FAILURE = "CREATE_THEME_FAILURE";

export const UPDATE_THEME_REQUEST = "UPDATE_THEME_REQUEST";
export const UPDATE_THEME_SUCCESS = "UPDATE_THEME_SUCCESS";
export const UPDATE_THEME_FAILURE = "UPDATE_THEME_FAILURE";

export const DELETE_THEME_REQUEST = "DELETE_THEME_REQUEST";
export const DELETE_THEME_SUCCESS = "DELETE_THEME_SUCCESS";
export const DELETE_THEME_FAILURE = "DELETE_THEME_FAILURE";

export const LIST_THEME_REQUEST = "LIST_THEME_REQUEST";
export const LIST_THEME_SUCCESS = "LIST_THEME_SUCCESS";
export const LIST_THEME_FAILURE = "LIST_THEME_FAILURE";

export const createTheme = (data, toggle, setData) => {
    return async (dispatch) => {
        try {
            dispatch({ type: CREATE_THEME_REQUEST });
            // upload icon on s3
            const imgRes = await axios.post(`${process.env.REACT_APP_BASE_URL}/s3/upload/yaadein/images/v1`, {
                sFileName: data.url.file.name,
                sContentType: data.url.file.type
            }, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            const imageUrl = imgRes.data.data.sUrl
            const sImage = imgRes.data.data.sPath
            await axios.put(imageUrl, data.url.file, { headers: { "Content-Type": data.url.file.type } });

            const url = `${baseUrl}/yaadein/themes/create/v1`;
            const response = await axios.post(url, { ...data, url: sImage }, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            dispatch({ type: CREATE_THEME_SUCCESS, payload: { data: { ...response.data.data, categoryDetails: data.categoryDetails } } });
            toast("Theme Created Successfully.");
            toggle();
            setData({
                name: "",
                icon: "",
                isInput: false,
                placeholder: ""
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: CREATE_THEME_FAILURE, payload: error.message });
            toast(error?.response?.data?.message);
        }
    }
};

export const updateTheme = (id, data, toggle, setData, setSelectedData) => {
    console.log('data inside a updateMusic', data)
    return async (dispatch) => {
        try {
            dispatch({ type: UPDATE_THEME_REQUEST });
            let icon = "";

            // upload icon on s3
            if (data && data.url && data.url.file) {
                const imgRes = await axios.post(`${process.env.REACT_APP_BASE_URL}/s3/upload/yaadein/images/v1`, {
                    sFileName: data.url.file.name,
                    sContentType: data.url.file.type
                }, {
                    headers: {
                        Authorization: localStorage.getItem("token")
                    }
                });
                const imageUrl = imgRes.data.data.sUrl
                icon = imgRes.data.data.sPath
                await axios.put(imageUrl, data.url.file, { headers: { "Content-Type": data.url.file.type } });
            }

            const url = `${baseUrl}/yaadein/themes/update/${id}/v1`;
            const response = await axios.put(url, { ...data, url: icon === "" ? data.url : icon }, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            dispatch({ type: UPDATE_THEME_SUCCESS, payload: { data: { ...response.data.data, categoryDetails: data.categoryDetails } } });
            toast("Theme Updated Successfully.");
            toggle();
            setData({
                name: "",
                icon: "",
                isInput: false,
                placeholder: "",
            });
            setSelectedData({});
        } catch (error) {
            console.error(error);
            dispatch({ type: UPDATE_THEME_FAILURE, payload: error.message });
            toast(error?.response?.data?.message);
        }
    }
};

export const deleteTheme = (id, selectedData, toggle) => {
    return async (dispatch) => {
        try {
            dispatch({ type: DELETE_THEME_REQUEST });
            const url = `${baseUrl}/yaadein/themes/delete/${id}/v1`;
            const response = await axios.delete(url, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            dispatch({ type: DELETE_THEME_SUCCESS, payload: id });
            toast("Theme Deleted Successfully.");
            toggle();
            selectedData({});
        } catch (error) {
            console.error(error);
            dispatch({ type: DELETE_THEME_FAILURE, payload: error.message });
            toast(error?.response?.data?.message);
        }
    }
};

export const listTheme = (skip, search, category) => {
    return async (dispatch) => {
        try {
            dispatch({ type: LIST_THEME_REQUEST });
            const url = `${baseUrl}/yaadein/themes/admin/list/v1?skip=${skip}&search=${search}&category=${category}`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            dispatch({ type: LIST_THEME_SUCCESS, payload: response.data });
        } catch (error) {
            console.error(error);
            dispatch({ type: LIST_THEME_FAILURE, payload: error.message });
            toast(error?.response?.data?.message);
        }
    }
};